module.exports = __webpack_public_path__ + "static/brand2-870bc24f0c035d6603530628f3295849.jpeg";